import React, { useMemo } from "react";
import "./exhibitors.css";

type Exhibitor = { logo: string; alt: string; link: string };

const EXHIBITORS: Exhibitor[] = [
  {
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1758250485/ajman_colored_lki1kt.png",
    alt: "Ajman Bank",
    link: "https://www.ajmanbank.ae/site/",
  },
  {
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1752837167/mashreq_xcf6fw.png",
    alt: "Mashreq",
    link: "https://www.mashreq.com/en/uae/neo/",
  },
  {
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1750072620/finastra_dz6iew.png",
    alt: "Finastra",
    link: "https://www.finastra.com/solutions/treasury-capital-markets",
  },
  {
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1754560447/TP_ICAP_Logo_Master_ej8vzo.png",
    alt: "TP ICAP",
    link: "https://tpicap.com/tpicap/",
  },
  {
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1758534822/360t_cropped_yvm0tx.png",
    alt: "360T",
    link: "https://www.360t.com/",
  },
  {
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1758250484/murex_colored_lfwxq4.png",
    alt: "Murex",
    link: "https://www.murex.com/en",
  },
  {
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1757613919/lseg_scwqth.png",
    alt: "LSEG",
    link: "https://www.lseg.com/en",
  },
  {
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1758709919/INTEGRAL_Logo_Black_zzjwhi.png",
    alt: "Integral",
    link: "https://www.integral.com/",
  },
  {
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1758711295/FranfurSchool_Logo_2x_v8ml7e.png",
    alt: "Frankfurt School",
    link: "https://www.frankfurt-school.de/en/home",
  },
  {
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1759860964/MakGroupLogo_2x_keilra.png",
    alt: "United MakGroup",
    link: "https://makgroup.ae/",
  },
  {
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1760964056/Smartiline_Global_PNG_iq3s7m.png",
    alt: "Smartline Global",
    link: "https://www.smartlineglobal.com/",
  },
  {
    logo: "https://res.cloudinary.com/astcdubai/image/upload/v1762322732/Kinetix_Logo_Color_e59vnr.png",
    alt: "Kinetex",
    link: "https://kinetixtt.com/contracts-intelligence/",
  },
];

const ExhibitorsSection: React.FC = () => {
  const sorted = useMemo(
    () => [...EXHIBITORS].sort((a, b) => a.alt.localeCompare(b.alt)),
    []
  );

  // Duplicate for seamless scrolling
  const loop = useMemo(() => [...sorted, ...sorted], [sorted]);

  return (
    <section id="exhibitors" className="ica-exh-section">
      <div className="container">
        <div className="row">
          <div className="col-sm-8 col-sm-offset-2 mb-20 text-center">
            <h1 className="title">Exhibitors</h1>
          </div>
        </div>

        <div
          className="ica-exh-banner"
          aria-label="Exhibitors logos carousel"
          role="region"
        >
          {/* mask/fades (hidden on white but useful if you re-theme) */}
          <span
            className="ica-exh-edge ica-exh-edge--left"
            aria-hidden="true"
          />
          <span
            className="ica-exh-edge ica-exh-edge--right"
            aria-hidden="true"
          />

          {/* Marquee wrapper (keeps overflow hidden) */}
          <div className="ica-exh-marquee" tabIndex={0}>
            <ul className="ica-exh-track" aria-hidden="false">
              {loop.map((x, i) => (
                <li className="ica-exh-item" key={`${x.alt}-${i}`}>
                  <a
                    className="ica-exh-link"
                    href={x.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={x.alt}
                    title={x.alt}
                  >
                    <img src={x.logo} alt={x.alt} loading="lazy" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExhibitorsSection;
